import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const SystemHeader = ({ name }) => {
  return (
    <>
      <div className='header pb-8 pt-5 pt-lg-8 d-flex align-items-center'>
        {/* Mask */}
        <span className='mask bg-gray' />
        {/* Header container */}
        <Container className='d-flex align-items-center' fluid>
          <Row>
            <Col lg='7' md='10'>
              <h1 className='display-2 text-white'>
                {name === undefined ? '' : `Olá ${name}`}
              </h1>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SystemHeader;
